<template>
  <div class="reaction-container">
    <BackTop />
    <div class="reaction" style="background: white; padding-top: 40px;">
      <div
        v-for="(item, index) in contentBriefs"
        :key="index"
        style="padding: 0 20px 40px; display: flex; justify-content: center;"
      >
        <SmilesItem :yield1="item.yield" :index="index" :str="item" />
      </div>
      <v-progress-linear
        indeterminate
        background-color="#f9f9f9"
        color="#999 "
        v-if="isLoading"
        class="mt-n4 mb-6"
      >
      </v-progress-linear>
      <div
        v-if="!showSmiles"
        style="
          background: white;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
      >
        <div v-if="!noResults">
          <img
            src="../assets/searching.gif"
            alt=""
            style="width: 200px; height: 200px;"
          />
        </div>
        <div v-else>
          <img
            src="../assets/noResult.png"
            alt=""
            style="width: 200px; height: 200px;"
          />
          <div class="text-center">无搜索结果</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "reaction",
  components: {},
  data() {
    return {
      showSmiles: false,
      index: 1,
      contentBriefs: [],
      pageTotal: 1,
      noResults: false,
      isLoading: false,
    };
  },
  mounted() {
    let data = JSON.parse(window.localStorage.getItem("reactionConditions"));
    this.reactionSearch({
      type: "reaction",
      index: this.index,
      smiles: data.smiles,
    })
      .then((res) => {
        if (res.data.code === 400) {
          this.$router.push("/");
        } else if (res.data.code === 701 || res.data.code === 702) {
          this.noResults = true;
        } else {
          this.pageTotal = res.data.data.pageTotal;
          this.contentBriefs = this.contentBriefs.concat(this.briefs);
          setTimeout(() => {
            this.showSmiles = true;
          }, 500);
          this.index = this.index + 1;
        }
      })
      .catch((error) => {
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      });

    window.onscroll = () => {
      //文档内容实际高
      let scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      //滚动条滚动距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //窗口可视范围高度
      let clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        );

      if (clientHeight + scrollTop >= scrollHeight) {
        if (this.index <= this.pageTotal) {
          this.isLoading = true;
          this.reactionSearch({
            type: "reaction",
            index: this.index,
            smiles: data.smiles,
          }).then((res) => {
            this.isLoading = false;
            if (res.data.code === 500) {
              alert("无搜索结果");
              this.$router.push("/");
            } else {
              this.contentBriefs = this.contentBriefs.concat(this.briefs);
              this.showSmiles = true;
              this.index = this.index + 1;
            }
          });
        }
      }
    };
  },
  computed: {
    ...mapState(["briefs"]),
  },
  methods: {
    ...mapActions(["reactionSearch"]),
  },
};
</script>

<style lang="scss">
ul,
li {
  list-style: none;
}

.reaction-container {
  width: 100%;
  padding-top: 20px;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;

  .reaction {
    max-width: 1400px;
    min-width: 1000px;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .reaction-content {
      width: 100%;
      flex-grow: 1;

      .reaction-content-items {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .reaction-content-item {
          width: 100%;
          border: 1px solid #999;
          border-bottom: none;
        }

        .reaction-content-item:last-child {
          border-bottom: 1px solid #999;
        }
      }
    }
  }
}
</style>
